<template>
  <div class="formCard">
    <div class="formCard_title">
      {{title}}
      <i v-if="showClose" class="el-icon-close close" @click="$emit('close')"></i>
    </div>
    <div class="formCard_content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "showClose"],
  data() {
    return {
      form: {}
    };
  }
};
</script>

<style lang="scss" scoped>
.formCard {
  background-color: #fff;
  border: 2px solid rgba(239, 239, 243, 1);
  margin-top: 24px;
  overflow: hidden;
}
.formCard_title {
  position: relative;
  text-align: center;
  color: #323232;
  font-size: 18px;
  padding: 12px;
  border-bottom: 2px solid rgba(239, 239, 243, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.formCard_content {
  background-color: #fff;
}
.close {
  position: absolute;
  right: 12px;
  color: #bbbbcf;
  cursor: pointer;
}
.form_box {
  max-width: 760px;
  margin: 24px auto;
  padding-left: 14px;
  padding-right: 14px;
}
</style>